import { render } from "./cdrBatchType.vue?vue&type=template&id=35dcbae6&scoped=true"
import script from "./cdrBatchType.vue?vue&type=script&lang=js"
export * from "./cdrBatchType.vue?vue&type=script&lang=js"

import "./cdrBatchType.vue?vue&type=style&index=0&id=35dcbae6&scoped=true&lang=css"
import "./cdrBatchType.vue?vue&type=style&index=1&id=35dcbae6&lang=css"
script.render = render
script.__scopeId = "data-v-35dcbae6"

export default script